'use client';

import Quote from '@/components/typography/quote';
import Copiable from '@/components/ui/copiable';
import { useTranslation } from 'react-i18next';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <div>
            <div className="flex min-h-[calc(15rem+77px)] flex-col items-center justify-center border-black px-4 lg:min-h-[calc(27rem+77px)] lg:p-4">
                <div className="mt-[77px] max-w-[1251px] text-center">
                    <Quote className="inline">
                        {t('hero.text')}
                        &nbsp;
                        <br className="hidden lg:block" />
                        <Copiable
                            label={t('hero.call')}
                            value={t('info.phone')}
                            className="abc-italic underline decoration-2 underline-offset-5 hover:no-underline lg:decoration-3"
                        >
                            {t('hero.call')}
                        </Copiable>
                        <span className="mr-2">{t('hero.or')}</span>
                        <Copiable
                            label={t('hero.email')}
                            value={t('info.emailAddress')}
                            className="abc-italic underline decoration-2 underline-offset-5 hover:no-underline lg:decoration-3"
                        >
                            {t('hero.email')}
                        </Copiable>
                        <span>{t('hero.usOr')}</span>
                        <Copiable
                            label={t('hero.visit')}
                            value={t('info.addressLink')}
                            className="abc-italic underline decoration-2 underline-offset-5 hover:no-underline lg:decoration-3"
                        >
                            {t('hero.visit')}
                            <span>!</span>
                        </Copiable>
                    </Quote>
                </div>
            </div>
        </div>
    );
}
